// Shared per-size dimensions/gaps for selection controls (Checkbox, Radio), matching the VUI v5
// Figma spec: control xs=16/sm=20/md=24, group gaps xs=8px/sm=12px/md=12px. `lg` is kept as a
// deprecated alias for `md` on both components (see `useDeprecatedLgSize`).
export const selectionControlSizes = {
  xs: { control: { h: 16, w: 16 }, label: { size: 'xs' } },
  sm: { control: { h: 20, w: 20 }, label: { size: 'sm' } },
  md: { control: { h: 24, w: 24 }, label: { size: 'md' } },
  /** @deprecated Use `md` instead — `lg` is kept as an alias for backwards compatibility. */
  lg: { control: { h: 24, w: 24 }, label: { size: 'md' } },
} as const

// Gap between individual controls in a group stack, and between the group label/help text and the stack.
export const selectionControlStackGap: Record<string, string> = { lg: '12px', md: '12px', sm: '12px', xs: '8px' }
export const selectionControlGroupGap: Record<string, string> = { lg: '12px', md: '12px', sm: '12px', xs: '8px' }
export const selectionControlLabelSize: Record<string, 'md' | 'sm' | 'xs'> = {
  lg: 'md',
  md: 'md',
  sm: 'sm',
  xs: 'xs',
}
